<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

    <main class="auth-main auth-main--flow auth-main--entry">
      <div class="auth-main__content">
        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          @if (sessionExpired) {
            <div class="auth-info-banner auth-info-banner--warn" role="status">
              <p class="auth-info-banner__text">{{ 'auth.welcome.sessionExpired' | translate }}</p>
            </div>
          }

          <h1 class="auth-panel__title">{{ 'auth.welcome.headline' | translate }}</h1>
          <p class="auth-panel__subtitle">{{ 'auth.welcome.tagline' | translate }}</p>

          <a class="auth-btn-primary auth-btn-primary--link" [routerLink]="['/authentication/login']">
            {{ 'auth.welcome.loginCta' | translate }}
          </a>

          <div class="auth-panel__secondary">
            <span class="auth-panel__secondary-hint">{{ 'auth.welcome.registerHint' | translate }}</span>
            <a class="auth-btn-secondary" [routerLink]="['/authentication/register']">
              {{ 'auth.welcome.registerCta' | translate }}
            </a>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
